<template>
  <div class="day" v-if="this.items.length > 1">
    <span>Journées</span>
    <div>
      <button v-for="item in items" :key="item.id" @click="change" :data="item.id" :title="title(item)">{{ name(item) }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SportGamesFiltersDayDay',
  data () {
    return {
      value: null
    }
  },
  computed: {
    items () {
      return this.$store.getters['Sport/Day/list']
    }
  },
  methods: {
    name (item) {
      return item.name + (item.deferred ? '(R)' : '')
    },
    title (item) {
      let value = item.name
      if (item.date) {
        const date = new Date(item.date)
        value += ' - ' + date.toLocaleDateString('fr')
      }
      value += ' [' + item.id + ']'
      return value
    },
    change (event) {
      const button = event.target
      const value = parseInt(button.getAttribute('data'))
      if (value === this.value) {
        this.value = null
        button.className = ''
      } else {
        button.parentNode.querySelectorAll('button').forEach(item => { item.className = '' })
        this.value = value
        button.className = 'selected'
      }
      this.$emit('change', this.value)
    }
  }
}
</script>

<style scoped>
  .day{
    display:flex;
    flex-direction:column;
    margin-bottom:10px
  }
  .day > span{
    font-size:14px;
    margin-bottom:5px
  }
  .day > div{
    background-color:var(--color-primary);
    padding:5px;
    border-radius:4px
  }
  .day > div > button{
    background-color:transparent;
    border-width:1px;
    border-style:solid;
    border-radius:4px;
    flex:auto;
    cursor:pointer;
    transition:all .5s ease-in-out;
    margin:0 5px
  }
  .day > div > button.selected{
    color:var(--color-primary);
    background-color:var(--color-primary-bg)
  }
  .day > div > button:hover{
    color:var(--color-primary-bg);
    border-color:var(--color-primary-bg)
  }
  .day > div > button.selected:hover{
    color:var(--color-primary);
    background-color:var(--color-primary-bg)
  }
</style>
